<script setup lang="ts">
import { watchEffect, ref } from 'vue'
import VLazyImage from 'v-lazy-image'
import { IMAGE_LINK_DEFAULT } from '~/constants'
const props = defineProps({
  src: {
    type: String,
    require: true,
    default: ''
  },
  imageDefault: {
    type: String,
    default: ''
  },
  alt: {
    type: String,
    default: ''
  }
})
const imageSrc = ref<string>(props.src)
const imageSrcDefault = props.imageDefault || IMAGE_LINK_DEFAULT
const checkImageError = (): void => {
  imageSrc.value = imageSrcDefault
}
watchEffect(() => {
  imageSrc.value = props.src
})
</script>
<template>
  <div class="base-image">
    <v-lazy-image
      v-bind="$attrs"
      :src="imageSrc"
      @error="checkImageError"
      :src-placeholder="imageSrcDefault"
      :alt="alt"
    />
  </div>
</template>

<style lang="scss" scoped>
.base-image {
  position: relative;
  .v-lazy-image {
    transition: all 0.3s;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
</style>
